import { Link } from 'react-router';
import { RoutePaths } from '@shared/utils';
import { ButtonV2 } from '@shared/widgets';

export const RecoveryResetPick = () => {
  return (
    <>
      <div className='mb-6 text-center text-sm uppercase'>What do you need to recover:</div>
      <div className='mb-2.5'>
        <Link to={RoutePaths.userNameRecovery.onNavigate()}>
          <ButtonV2 className='!h-[56px]' fullWidth>
            Recover username
          </ButtonV2>
        </Link>
      </div>
      <div className='mb-6'>
        <Link to={RoutePaths.passwordRecovery.onNavigate()}>
          <ButtonV2 className='!h-[56px]' fullWidth>
            Recover password
          </ButtonV2>
        </Link>
      </div>
      <div>
        <Link to={RoutePaths.login.onNavigate()}>
          <ButtonV2 className='!h-[56px]' color='outlined' fullWidth>
            Cancel
          </ButtonV2>
        </Link>
      </div>
    </>
  );
};
